import axios from "axios";
import { axiosUser } from "config/axios.config";

const REPORT_URL = "/report";

let BASE_URL_CALL_REPORT = '';
let BASE_URL_WA_REPORT= '';
let BASE_URL_EMAIL_REPORT= '';
let BASE_URL_SMS_REPORT= '';
if(localStorage.getItem('current_set') === 'staging'){
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_REPORT_STAGING_V4
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_REPORT_STAGING_V4
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_REPORT_STAGING_V4
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
}else{
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_REPORT_RATE
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_REPORT_RATE
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_REPORT_RATE
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
}

const configHeader = (appId) => (
    {'x-application-key': `${appId}`,'Content-Type': 'application/json;charset=UTF-8', "Access-Control-Allow-Origin": "*" }
  )

const reportSvc = {
    getAll: async (channelId, applicationId, startDate, endDate) => {
        const response = await axiosUser.get(`${REPORT_URL}?channelId=${channelId}&startDate=${startDate}&endDate=${endDate}&applicationId=${applicationId}`);
        return response;
    },
    axiosEmailReport: async (body, appId) => {
        const user = await axios.post(`${BASE_URL_EMAIL_REPORT}/email/report/rate`, body, { headers: configHeader(appId) });
        return user;
    },
    axiosWhatsappReport: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_WA_REPORT}/wa-records/rate`, data, { headers: configHeader(appId) });
        return user;
    },
    axiosCallReport: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_CALL_REPORT}/call/report/rate`, data, { headers: configHeader(appId) });
        return user;
    },
    axiosCallOTPReport: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_CALL_REPORT}/otp-call/report/rate`, data, { headers: configHeader(appId) });
        return user;
    },
    axiosSMSReport: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_SMS_REPORT}/sms/success-rate`, data, { headers: configHeader(appId) });
        return user;
    },
    axiosSMSOTPReport: async (data, appId) => {
        const user = await axios.post(`${BASE_URL_SMS_REPORT}/otp/success-rate`, data, { headers: configHeader(appId) });
        return user;
    },
    axiosSMSDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/sms/success-rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosSMSDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/sms/success-rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
    axiosSMSOTPDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/otp/success-rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosSMSOTPDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_SMS_REPORT}/otp/success-rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
    axiosCallDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_CALL_REPORT}/call/report/rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosCallDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_CALL_REPORT}/call/report/rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
    axiosCallOTPDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_CALL_REPORT}/otp-call/report/rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosCallOTPDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_CALL_REPORT}/otp-call/report/rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
    axiosEmailDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_EMAIL_REPORT}/email/report/rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosEmailDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_EMAIL_REPORT}/email/report/rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
    axiosWhatsappDownload: async (params, appId) => {
        const user = await axios.get(`${BASE_URL_WA_REPORT}/wa-records/rate/download?${params}`, { headers: configHeader(appId) });
        return user;
    },
    axiosWhatsappDownloadBuffer: async (params, applicationData) => {
        const user = await axios.get(`${BASE_URL_WA_REPORT}/wa-records/rate/download?${params}`,
            {
                responseType: "blob",
                headers: {
                    'x-application-key': `${applicationData}`, "Access-Control-Allow-Origin": "*"
                }
            });
        return user;
    },
};

export default reportSvc;
